<script lang="ts" setup>
import type { Component, Page } from '@bloomreach/spa-sdk'
import { toRefs } from 'vue'

/**
 * SDX
 */

const props = defineProps<{
    component: Component
    page: Page
}>()

const { component, page } = toRefs(props)
const documentRef = computed(() => component.value.getModels().document)
const document = computed(() => documentRef.value && page.value.getContent<Document>(documentRef.value))
const data = computed(() => document.value?.getData())

const { content, fullname, image, pageHeading, role } = data?.value
const dataAuthorImg = computed(() => image?.$ref && page.value.getContent<Document>(image?.$ref))
const authorImg = useImageRef(dataAuthorImg)
</script>

<template>
    <article class="mb-2 mt-12 lg:mb-8 lg:mt-16">
        <header class="mx-auto my-12 mb-6 px-4 text-center lg:my-16">
            <h1
                class="mb-2 font-barlow-condensed text-4xl font-bold md:text-heading-44"
                v-html="pageHeading.title"
            />
            <p class="text-pretty text-lg font-bold md:text-2xl">
                {{ pageHeading.description }}
            </p>
        </header>
        <section class="bg-plush-gray-40 lg:py-16">
            <div class="mx-auto max-w-6.5xl items-start justify-start gap-20 lg:flex lg:pr-4">
                <AtomImage
                    :src="authorImg.src"
                    :alt="authorImg.alt"
                    img-class="lg:max-w-[27%] lg:min-w-[336px]"
                />
                <div class="px-3 py-12 lg:p-0">
                    <h2
                        class="text-lg font-bold md:text-2xl lg:text-3xl"
                        v-html="fullname"
                    />
                    <p
                        class="mb-4 text-sm font-medium md:text-lg lg:text-xl"
                        v-html="role"
                    />
                    <div
                        class="max-w-prose font-medium md:text-lg lg:text-xl"
                        v-html="content?.value"
                    />
                </div>
            </div>
        </section>
    </article>
</template>
